function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:none;stroke:#492cbd;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "mail",
  transform: "translate(480.645 625.836)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9656",
  "data-name": "Path 9656",
  className: "cls-2",
  d: "M3.771 4h14.168a1.776 1.776 0 0 1 1.771 1.771V16.4a1.776 1.776 0 0 1-1.771 1.771H3.771A1.776 1.776 0 0 1 2 16.4V5.771A1.776 1.776 0 0 1 3.771 4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9657",
  "data-name": "Path 9657",
  className: "cls-2",
  d: "m19.71 6-8.855 6.2L2 6",
  transform: "translate(0 -.229)"
}));

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Group_9106",
    "data-name": "Group 9106",
    transform: "translate(-464 -609.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9659",
    "data-name": "Path 9659",
    d: "M27.5 0A27.5 27.5 0 1 1 0 27.5 27.5 27.5 0 0 1 27.5 0z",
    transform: "translate(464 609.42)",
    style: {
      fill: "#492cbd",
      opacity: 0.063
    }
  }), _ref3));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.eee05931.svg";
export { ForwardRef as ReactComponent };